import React from "react";
import { TextField } from "@mui/material";

const PurchaseOrderTermsAndDelivery = ({
  purchaseOthersData,
  setPurchaseOthersData,
}) => {
  return (
    <div className="grid grid-cols-1 lg:grid-cols-12 gap-4 mt-4">
      <div className="lg:col-span-6 col-span-1 flex flex-col gap-4">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-4">
          <TextField
            label="Terms"
            variant="outlined"
            size="small"
            value={purchaseOthersData?.terms || ""}
            onChange={(e) =>
              setPurchaseOthersData({
                ...purchaseOthersData,
                terms: e.target.value,
              })
            }
            fullWidth
          />

          <TextField
            label="Delivery"
            variant="outlined"
            size="small"
            value={purchaseOthersData?.delivery || ""}
            onChange={(e) =>
              setPurchaseOthersData({
                ...purchaseOthersData,
                delivery: e.target.value,
              })
            }
            fullWidth
          />
        </div>

        {/* Row: C&F Agent + Ship Ref */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-4">
          <TextField
            label="C&F Agent"
            variant="outlined"
            size="small"
            value={purchaseOthersData?.cfAgent || ""}
            onChange={(e) =>
              setPurchaseOthersData({
                ...purchaseOthersData,
                cfAgent: e.target.value,
              })
            }
            fullWidth
          />

          <TextField
            label="Ship Ref"
            variant="outlined"
            size="small"
            value={purchaseOthersData?.shipRef || ""}
            onChange={(e) =>
              setPurchaseOthersData({
                ...purchaseOthersData,
                shipRef: e.target.value,
              })
            }
            fullWidth
          />
        </div>
      </div>
      <div className="lg:col-span-6 col-span-1 grid grid-cols-1 lg:grid-cols-4 gap-4">
        <div className="flex flex-col gap-4 lg:col-span-2">
          <TextField
            label="LC No"
            variant="outlined"
            size="small"
            value={purchaseOthersData?.lcNo || ""}
            onChange={(e) =>
              setPurchaseOthersData({
                ...purchaseOthersData,
                lcNo: e.target.value,
              })
            }
            fullWidth
          />

          <TextField
            label="Ship Date"
            type="date"
            variant="outlined"
            size="small"
            value={
              purchaseOthersData?.shipDate ||
              new Date().toISOString().split("T")[0]
            }
            onChange={(e) =>
              setPurchaseOthersData({
                ...purchaseOthersData,
                shipDate: e.target.value,
              })
            }
            InputLabelProps={{ shrink: true }}
            fullWidth
          />
        </div>

        <div className="lg:col-span-2">
          <TextField
            label="Remarks"
            variant="outlined"
            size="small"
            multiline
            minRows={3.4}
            value={purchaseOthersData?.remarks || ""}
            onChange={(e) =>
              setPurchaseOthersData({
                ...purchaseOthersData,
                remarks: e.target.value,
              })
            }
            fullWidth
            className="h-full"
          />
        </div>
      </div>
    </div>
  );
};

export default PurchaseOrderTermsAndDelivery;
